import { render, staticRenderFns } from "./IpsSelect.vue?vue&type=template&id=94bbab2a&scoped=true"
import script from "./IpsSelect.vue?vue&type=script&lang=js"
export * from "./IpsSelect.vue?vue&type=script&lang=js"
import style0 from "./IpsSelect.vue?vue&type=style&index=0&id=94bbab2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bbab2a",
  null
  
)

export default component.exports